import * as actions from "store/actions/nfse/detail";
import INFSe from "Types/INFSe";
import ISplit from "Types/Split";

export interface NFSeDetailState {
	item: INFSe;
	splits: ISplit[];
	loading: { get: boolean; split: boolean };
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: NFSeDetailState = {
	item: {},
	splits: [],
	loading: { get: false, split: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_NFSE: {
			return {
				...state,
				loading: { ...state.loading, get: true },
				errors: initialState.errors
			};
		}
		case actions.GET_NFSE_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				item: payload
			};
		}
		case actions.GET_NFSE_FAILED: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				errors: payload
			};
		}
		case actions.GET_SPLITS: {
			return {
				...state,
				loading: { ...state.loading, split: true },
				errors: initialState.errors
			};
		}
		case actions.GET_SPLITS_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, split: false },
				splits: payload || []
			};
		}
		case actions.GET_SPLITS_FAILED: {
			return {
				...state,
				loading: { ...state.loading, split: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
